/** Variante do tema do Avatar por tamanho do cartão: 56 no hover (Figma 9961:116556), 64 nos modais. */
export const AVATAR_CLASS_BY_SIZE = { md: "p-avatar-56", lg: "p-avatar-64" } as const;

/** Anotação do Figma no ícone de copiar (info-user-card 9961:116544). */
export const COPY_EMAIL_TOOLTIP = "Clique para copiar";
export const COPY_EMAIL_COPIED_TOOLTIP = "Copiado";
/** Quanto tempo o tooltip mostra "Copiado" antes de voltar à anotação. */
export const COPIED_FEEDBACK_MS = 2000;
export const COPY_EMAIL_ERROR_SUMMARY = "Não foi possível copiar o e-mail";
export const COPY_EMAIL_ERROR_DETAIL = "Selecione o endereço no cartão e copie manualmente.";
